/**
 * Invitation à passer l'appareil en paysage (DECISIONS **A-11**).
 *
 * Le jeu reste **entièrement jouable en portrait** (canvas 16:9 en `scale.mode = FIT`, aucun
 * canvas mobile spécifique) ; cette invitation n'est qu'un conseil d'ergonomie : le parcours de
 * 32 colonnes se vise mieux quand la largeur de l'écran est la plus grande.
 *
 * Elle est donc **non bloquante** par construction :
 * - aucun bouton, aucun lien, aucune zone de tap (`pointer-events: none`) : elle n'intercepte pas
 *   le geste du joueur et n'entre ni dans la mesure des cibles tactiles (≥ 44 px, A-9.5), ni dans
 *   celle des chevauchements de zones de tap ;
 * - elle ne s'affiche qu'en **portrait sur téléphone et tablette** (`styles/invitation-paysage.css`,
 *   `@media (orientation: portrait) and (max-width: 1024px)`) : en paysage et sur bureau, la
 *   règle CSS vaut `display: none`, donc elle n'ajoute aucune hauteur et ne peut pas provoquer de
 *   débordement (défaut D-M4-09-02) ;
 * - en portrait, elle tient sur la ligne de titre du briefing : aucune ligne n'est ajoutée à
 *   l'écran (les écrans portrait sont déjà serrés, D-M4-09-02 et R-M4-09-01) ;
 * - le texte visible vient du catalogue d'interface FR/EN (`jeu.invitationPaysage`) ; la phrase
 *   complète est exposée aux lecteurs d'écran par `aria-label`
 *   (`jeu.invitationPaysageDetail`). Aucun libellé écrit en dur.
 */
import { useTranslation } from 'react-i18next';

export function InvitationPaysage() {
  const { t } = useTranslation();
  return (
    <p
      className="invitation-paysage"
      role="note"
      aria-label={t('jeu.invitationPaysageDetail')}
      data-invitation-paysage="oui"
    >
      {t('jeu.invitationPaysage')}
    </p>
  );
}
